import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";

// Components
import Login from "./components/Login";
import Dashboard from "./components/Dashboard";
import Customers from "./components/Customers";
import CustomerDetail from "./components/CustomerDetail";
import Transactions from "./components/Transactions";
import Navbar from "./components/Navbar";
import PrivateRoute from "./components/PrivateRoute";
import Profile from "./components/Profile";
import Settings from "./components/Settings";
import LandingPage from "./components/Landingpage"; // Fixed import
import CustomerDashboard from "./components/CustomerDashboard"; // Fixed import
import AdminInstallations from "./components/AdminInstallations";
import NewRequest from "./components/NewRequest"; // Add this component

// Placeholder components for other routes
const Reports = () => (
  <div className="container mt-4">
    <h2>Reports</h2>
  </div>
);

function App() {
  return (
    <Router>
      <div className="App">
        <Navbar />

        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<Login />} />

          <Route
            path="/dashboard"
            element={
              <PrivateRoute>
                <CustomerDashboard />
              </PrivateRoute>
            }
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
